<button [attr.data-badge]="badgeThreadsCount" [matMenuTriggerFor]="menu" (menuOpened)="onMenuOpened()" mat-icon-button
    class="status-buttons badge">
    <mat-icon matTooltip="Processes Count" class="status-mat-icons">speed</mat-icon>
    <span class="allowed-threads-count-lbl" [ngClass]="dark?'dark-label':''"
        title="Active Threads count">{{process.allowedThreadsCount}}</span>
</button>


<mat-menu #menu="matMenu" panelClass="threads-slider-menu-panel">
    <div class="threads-slider-menu-content">
        <mat-slider class="threads-slider" [displayWith]="safeValue" tickInterval="1" min="1"
            [max]="availableThreadsCount" showTickMarks>
            <input matSliderThumb [value]="pendingMaxThreadsCount" (input)="handleThumbInput($event)"
                (click)="setTreadsCount()" (mouseleave)="setTreadsCount()" #slider>
        </mat-slider>
    </div>
</mat-menu>
